import React, { useState, useEffect, useRef } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { setSearchFormData } from '@/redux/actions/searchFormDataActions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Label from '@/components/form/Label/Label';

const SearchBar = (props) => {
  const { languageData, onBack } = props;
  return (
    <FlexContainer className={'margt60 align-items-end'}>
      <i className="fa fa-chevron-left" onClick={onBack}></i>
      <Label className={'fontWhite text-12 margl10'} onClick={onBack}>
        {languageData === 'EN' ? 'Back to space details' : 'Volver a los detalles del espacio'}
      </Label>
    </FlexContainer>
  );
};

const Pill = ({ active, label, hint, label_es, hint_es, onClick, languageData }) => {
  return (
    <button
      onClick={onClick}
      className={
        'flex-container border-rad10px margb4 padtb8 ' +
        (active ? 'borderPurpleGradients' : 'bgPurple12 borderPurpleShadow margb4')
      }
    >
      <div className="flex-1 text-left fontWhite text-14 margl20 flex-container align-items-center">
        <span style={{ minWidth: '120px' }}>{languageData === 'ES' ? label_es : label}</span>
        {hint && (
          <span className="margl10" style={{ opacity: 0.7 }}>
            {languageData === 'ES' ? hint_es : hint}
          </span>
        )}
      </div>
    </button>
  );
};

const options = [
  {
    title: 'Workspaces',
    title_es: 'Solo espacios de trabajo',
    items: [
      {
        id: 'day-pass',
        label: 'Day Pass',
        label_es: 'Pase por un día',
        hint: 'Shared Space',
        hint_es: 'Espacio compartido',
      },
    ],
  },
  {
    title: 'Team Rooms',
    title_es: 'Salas de Juntas',
    items: [
      {
        id: 'small',
        label: 'Small Room',
        label_es: 'Sala pequeña',
        hint: ' (2 - 4 People)',
        hint_es: ' (2 - 4 personas)',
      },
      {
        id: 'medium',
        label: 'Medium Room',
        label_es: 'Sala mediana',
        hint: ' (Up to 8 People)',
        hint_es: ' (Hasta 8 personas)',
      },
      {
        id: 'large',
        label: 'Large Room',
        label_es: 'Sala grande',
        hint: ' (Up to 15 People)',
        hint_es: ' (Hasta 15 personas)',
      },
    ],
  },
];
const LoginView = (props) => {
  const { languageData, onSelect, goToWorkspaceMap } = props;
  const currentSearchFormData = useSelector((state) => state.searchFormData);
  const defaultValue = currentSearchFormData?.spaceType === 'coworking' ? 'day-pass' : 'small';
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (onSelect) {
      onSelect(defaultValue);
    }
  }, [onSelect]);

  const handleSpaceType = (id) => {
    if (id === 'day-pass') {
      dispatch(setSearchFormData({ ...currentSearchFormData, spaceType: 'coworking' }));
    } else {
      dispatch(setSearchFormData({ ...currentSearchFormData, spaceType: 'sala de juntas' }));
    }
    navigate('/');
  };

  return (
    <FlexContainer className="flex-column padlr10 justify-start items-center bgGradientBlue fontWhite ">
      <SearchBar languageData={languageData} onBack={goToWorkspaceMap} />
      <FlexContainer className={'flex-column  height-511px margt30 '}>
        <FlexContainer className="flex-column gap-10 padb60">
          {options.map((block) => (
            <FlexContainer
              className="flex-column margb10"
              key={languageData === 'ES' ? block.title_es : block.title}
            >
              <FlexContainer className="margb8 fontWhite text-16">
                {languageData === 'ES' ? block.title_es : block.title}
              </FlexContainer>

              <FlexContainer className="flex-column">
                {block.items.map((opt) => (
                  <Pill
                    languageData={languageData}
                    key={opt.id}
                    label={opt.label}
                    label_es={opt.label_es}
                    hint={opt.hint}
                    hint_es={opt.hint_es}
                    active={value === opt.id}
                    onClick={() => {
                      setValue(opt.id);
                      handleSpaceType(opt.id);
                      if (onSelect) {
                        onSelect(opt.id);
                        console.log('selected:', opt.id);
                      }
                    }}
                  />
                ))}
              </FlexContainer>
            </FlexContainer>
          ))}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default LoginView;
